import {Component, Module} from 'app/decorators';
import tpl from './blnd.units.picker.tpl.html';


@Module({
    name: "app.directives.units.picker",
})
@Component({
    selector: 'blnd-units-picker',
    bindings: {
        ngModel: '=',
        mode: '@?',
    },
    template: tpl,
})
export default class C {
    constructor (Config) {
        "ngInject";
        this.units = Config.$config.units;
        this.mode = this.mode || 'view';
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/blnd.units.picker.js